import { render, staticRenderFns } from "./SizeProductDetail.vue?vue&type=template&id=58232d35"
import script from "./SizeProductDetail.vue?vue&type=script&lang=js"
export * from "./SizeProductDetail.vue?vue&type=script&lang=js"
import style0 from "./SizeProductDetail.vue?vue&type=style&index=0&id=58232d35&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports